<svg width="14" height="14" viewBox="0 0 14 14" fill="none">
  <path
    d="M11.6666 3.5L5.24992 9.91667L2.33325 7"
    stroke="#E4E7EC"
    strokeWidth="2.33333"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>
